"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT = void 0;
exports.TEXT = {
    PASSWORD1: 'Passwor',
    PASSWORD2: '密',
    PASSWORD3: '密碼'
};
